// src/components/RelatedPosts.jsx
import React from "react";
import { Link } from "react-router-dom";

/* Pick correct language from object or return string */
const pickLang = (value, lang) => {
  if (!value) return "";
  return typeof value === "object" ? value[lang] : value;
};

const RelatedPosts = ({ related, language = "en" }) => {
  if (!related || related.length === 0)
    return <p className="text-center"> {language === "ar"
          ? "لا توجد مقالات ذات صلة"
          : "No related posts available."}</p>;

  return (
    <div className="row justify-content-center">
      {related.map((r) => {
        const title = pickLang(r.title, language);
        const category = pickLang(r.category, language);

        return (
          <div className="col-md-4 mb-4" key={r.id}>
            <div className="card h-100 shadow-sm border-0">
              <img
                src={r.img}
                className="card-img-top"
                alt={title}
                style={{ height: "220px", objectFit: "cover" }}
              />

              <div className="card-body">
                <div className="small text-muted">
                  {category} • {r.date}
                </div>

                <h6 className="mt-2">{title}</h6>

                <Link
                  to={`/news/${language}/${r.id}`}
                  className={`explore-btn relate-btn cta-btn mb-5 gap-3 block-view ${
                    language === "ar" ? "ar-padding" : "en-padding"
                  }`}
                >
                  {language === "ar" ? "اقرأ المزيد →" : "Read More →"}
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RelatedPosts;
